module.exports = __webpack_public_path__ + "img/woodStand-7.34e84158.png";